import {
  generateFinalInvoiceActionType,
  generateFinalInvoiceSuccessActionType,
  generateFinalInvoiceFailureActionType,
} from 'actions/Lots/generateFinalInvoice';
import {
  uploadCustomFinalInvoiceType,
  uploadCustomFinalInvoiceSuccessType,
  uploadCustomFinalInvoiceFailureType,
} from 'actions/Lots/uploadCustomFinalInvoice';

const INITIAL_STATE = {
  isPending: false,
};

const finalInvoiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case generateFinalInvoiceActionType:
    case uploadCustomFinalInvoiceType:
      return {
        isPending: true,
      };
    case generateFinalInvoiceSuccessActionType:
    case generateFinalInvoiceFailureActionType:
    case uploadCustomFinalInvoiceSuccessType:
    case uploadCustomFinalInvoiceFailureType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};

export { finalInvoiceReducer };
